module.exports = __webpack_public_path__ + "assets/img/4df30dc8fa4487e5808db95aa9f656c6.svg";